<!--
frontend-author:bhavya, udayasankar,
backend-author: ,
page-name : product create.vue,
page-description : product create for invoice,
started at : 17-Apr-2019,
edited at :.
-->
<!-- Html code for product create-->
<template>
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div
      class="customer-create-page"
      v-else
      @click="roundOff()"
      style="padding-bottom: 180px; margin-top: -10px"
    >
      <!-- page title for product create -->
      <GlobalHeader title="Product" @redirectPage="redirectPage"></GlobalHeader>
      <!-- Validation for product -->
      <b-row class="mt-2 px-pad">
        <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="duplicatecode && Object.keys(message).length != 0">
              <p class="fw-semi-bold">{{ message }}</p>
            </b-alert>
            <b-alert class="alert-transparent alert-danger" :show="error_show && errors.any()">
              <button type="button" @click="error_show = !error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
              <p
                class="fw-semi-bold"
                v-for="item in errors.items"
                :key="item.id"
                v-if="item.scope == 'product-form'"
              >{{ item.msg }}</p>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <!-- page header for product create -->
      <b-form
        class="mt-3 pt-1"
        id="product_form"
        @submit.prevent="onSubmit('product-form')"
        method="post"
        data-vv-scope="product-form"
        style="margin-left: 3px; margin-right: 3px"
      >
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Type" label-for="type" class="mb-3" label-cols="4" horizontal>
              <b-form-radio-group
                class="mt-1"
                id="type"
                :options="type"
                name="pdt_state"
                v-model.trim="field.pdt_state"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px" class="mb-4">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group :label="'Name'" label-class="required" class="mb-3" label-for="pdt_name">
              <input
                v-model.trim="field.pdt_name"
                name="pdt_name"
                :class="{ 'form-control': true }"
                type="text"
                id="pdt_name"
                data-vv-name="product name"
                v-validate="'required|max:150'"
              />
            </b-form-group>

            <b-form-group class="mb-3" label="Unit" label-for="pdt_unit">
              <template slot="label">
                Unit
                <span class="text-danger">*</span>
                <span
                  v-b-tooltip.top="
                  'The product will be measured in terms of this unit(e.g: kg.dozen)'
                "
                >
                  <i class="la la-question-circle la-lg"></i>
                </span>
              </template>

              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-tooltip
                    title="Configure Unit"
                    v-b-modal.ConfigUnit
                  >
                    <i class="la la-sm la-cog"></i>
                  </b-input-group-text>
                </template>
                <template slot="prepend">
                  <v-select
                    class="form-vselect"
                    :clearable="false"
                    size="sm"
                    :options="unit_list"
                    label="label"
                    index="value"
                    id="pdt_unit-select"
                    data-vv-name="product unit"
                    name="pdt_unit"
                    v-model.trim="field.pdt_unit"
                    v-validate="'required'"
                  ></v-select>
                </template>
              </b-input-group>
            </b-form-group>
            <b-form-group
              class="mb-3"
              label-for="is_digital_service"
              v-if="
              is_digital_service &&
              field.pdt_state == 2 &&
              org_details.gst_type == 1
            "
            >
              <b-form-checkbox
                id="is_digital_service"
                v-model.trim="field.is_digital_service"
                name="is_digital_service"
                value="1"
                unchecked-value="0"
              >Digital service</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8" v-if="pdt_img">
            <div class="forms-elements" style="width: 160px; margin: 0 auto">
              <b-form-group>
                <input
                  accept="image/*"
                  @change="onChangeInputImage"
                  id="fileupload2"
                  type="file"
                  ref="file"
                  data-vv-name="product image"
                  v-validate="'image|size:200'"
                  name="Product image"
                  class="display-none"
                />

                <div class="fileinput-new thumbnail" style="position: relative">
                  <div v-if="imageFiles.length > 0">
                    <div
                      class="image-preview"
                      v-for="image in imageFiles"
                      :key="`img-id-${image.toString()}`"
                      :style="{ backgroundImage: `url(${image.preview})` }"
                    />
                  </div>
                  <div v-else class="org-logo"></div>
                </div>
                <div style="position: absolute; top: 0px">
                  <b-button
                    :style="{
                    position: imageFiles[0] ? 'absolute' : ' ',
                    top: imageFiles[0] ? '127px' : '',
                  }"
                    size="sm"
                    type="button"
                    variant="light"
                    style="width: max-content"
                    :class="[
                    !imageFiles[0] ? 'upload-logo-btn' : 'change-logo-btn',
                  ]"
                  >
                    <label for="fileupload2" class="m-0 p-0" style="cursor: pointer">
                      <i class="fa fa-upload text-decor-none"></i>
                      {{ !imageFiles[0] ? "Upload Image" : "Change Image" }}
                    </label>
                  </b-button>
                  <b-button
                    style="position: absolute; top: 127px; left: 126px"
                    class="delete-logo-btn text-danger"
                    type="button"
                    size="sm"
                    variant="light"
                    v-if="imageFiles[0]"
                    @click="deleteimage"
                  >
                    <label for class="m-0 p-0" style="cursor: pointer">
                      <span class="fa fa-trash-o fa-lg text-decor-none text-dark"></span>
                    </label>
                  </b-button>
                </div>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              v-if="org_details.gst_type == 1"
              class="mb-3"
              label-cols="4"
              horizontal
              label-class="required"
              label="Tax Preference"
              label-for="tax"
            >
              <b-form-radio-group
                class="mt-1"
                @input="
                (field.pdt_inter_tax_id =
                  field.tax_preference == '0'
                    ? {
                        label: 'Non Taxable',
                        value: '20',
                        sales_tax_percent: '0.00',
                      }
                    : ''),
                  (field.pdt_tax_id =
                    field.tax_preference == '0'
                      ? {
                          label: 'Non Taxable',
                          value: '19',
                          sales_tax_percent: '0.00',
                        }
                      : '')
              "
                @change="field.exempt_reason = ''"
                id="tax_preference"
                :options="taxable_preference"
                name="tax_preference"
                data-vv-name="tax preference"
                v-model.trim="field.tax_preference"
                v-validate="'required'"
              />
            </b-form-group>
            <b-form-group
              class="mb-3"
              label-class="required"
              label="Exempt Reason"
              label-for="exempt_reason"
              v-if="field.tax_preference == '0'"
            >
              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-tooltip
                    title="Add Exempt"
                    v-on:click="
                    (excemptmodal = true),
                      callexemptmodal({ value: '', label: '' })
                  "
                  >&#43;</b-input-group-text>
                </template>

                <template slot="prepend">
                  <v-select
                    :clearable="false"
                    data-vv-name="exempt reason"
                    size="sm"
                    :options="exempt_reason_list"
                    label="label"
                    index="value"
                    name="exempt_reason"
                    v-validate="'required'"
                    v-model.trim="field.exempt_reason"
                    class="form-vselect"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-flex w-100 v-select-option" :title="option.label">
                        <div class="text-truncate" style="width: 292px">{{ option.label }}</div>

                        <span class="select-hover-block">
                          <span
                            class="la la-edit la-lg float-right mr-2"
                            v-on:click.stop="
                            (excemptmodal = true),
                              callexemptmodal({
                                value: option.value,
                                label: option.label,
                              })
                          "
                          ></span>
                          <span
                            class="fa fa-trash-o fa-lg float-right mt-2p"
                            v-on:click.stop="
                            (excemptdelete = true),
                              (method = 'exemptdelete'),
                              (types = 'exempt'),
                              calldeletemodal(option.value)
                          "
                          ></span>
                        </span>
                      </div>
                    </template>
                  </v-select>
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          style="max-width: 1000px"
          v-if="field.tax_preference == '1' && org_details.gst_type == 1"
        >
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group :label="'Inter state Tax '" label-class="required" label-for="basic">
              <v-select
                :clearable="false"
                @input="inter_tax_id($event)"
                v-validate="'required'"
                data-vv-name="inter tax"
                name="pdt_inter"
                id="search-select"
                v-model.trim="field.pdt_inter_tax_id"
                size="sm"
                :options="
                igst_tax
                  .map((igstTax) => ({
                    label: igstTax.tax_name,
                    value: igstTax.tax_id,
                    sales_tax_percent: igstTax.sales_tax_percent,
                  }))
                  .filter((x) => x.value != 20)
              "
              />

              <span
                style="position: relative; top: 5px"
                v-if="field.pdt_tax_type == 1 && field.pdt_inter_tax_id != ''"
              >
                <small>
                  <p class="mb-1 pb-0">
                    Unit Price -
                    {{
                    parseFloat(
                    inclusiveAmount().pdt_incl_inter_price
                    ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    })
                    }}
                  </p>
                </small>
              </span>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group :label="'Intra state Tax '" label-class="required" label-for="basic">
              <v-select
                :clearable="false"
                @input="intra_tax_id($event)"
                data-vv-name="intra tax"
                v-validate="'required'"
                id="search-select"
                v-model.trim="field.pdt_tax_id"
                size="sm"
                :options="
                local_tax
                  .map((localTax) => ({
                    label: localTax.tax_name,
                    value: localTax.tax_id,
                    sales_tax_percent: localTax.sales_tax_percent,
                  }))
                  .filter((x) => x.value != 19)
              "
                name="pdt_intra"
              />

              <span
                style="position: relative; top: 5px"
                v-if="field.pdt_tax_type == 1 && field.pdt_tax_id != ''"
              >
                <small>
                  <p class="mb-1 pb-0">
                    Unit Price -
                    {{
                    parseFloat(
                    inclusiveAmount().pdt_incl_intra_price
                    ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    })
                    }}
                  </p>
                </small>
              </span>
              <input
                name="reorder_level"
                v-model.trim="field.warehouse_id"
                :class="{ 'form-control': true }"
                type="hidden"
                id="basic"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px" class="mt-1">
          <b-col cols="12" lg="5" md="6" sm="8" v-if="org_details.gst_type == 1">
            <b-form-checkbox
              v-if="field.tax_preference == '1'"
              id="pdt_tax_type"
              v-model.trim="field.pdt_tax_type"
              name="pdt_tax_type"
              value="1"
              unchecked-value="0"
            >Inclusive of tax</b-form-checkbox>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px" class="mt-5 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.sales-informations
            >
              Sales Informations
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="sales-informations" visible>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group :label="'Selling Price'" label-class="required" label-for="basic">
                <b-input-group :prepend="orgCurrency" class="mb-2 mr-sm-2 mb-sm-0 product_currency">
                  <b-input
                    data-vv-name="sales price"
                    v-validate="'required|max_value:100000000000000'"
                    @blur="roundOffItem('pdt_sal_price', 6)"
                    v-model.trim="field.pdt_sal_price"
                    name="pdt_sal_price"
                    :class="{ 'form-control': true }"
                    type="text"
                    id="basic"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group label="Sales Account" :label-class="'required'" label-for="basic">
                <select
                  v-model.trim="field.pdt_sales_account"
                  v-chosen="field.pdt_sales_account"
                  name="pdt_sales_account"
                  data-vv-name="sales account"
                  v-validate="'required'"
                  class="chosen v-select form-control"
                >
                  <optgroup :label="item.gl_acc_type" v-for="item in sales_account" :key="item.id">
                    <option
                      v-for="acc in acc_types"
                      :key="acc.id"
                      v-if="acc.gl_acc_type_id == item.gl_acc_type_id"
                      :value="acc.gl_acc_id"
                    >{{ acc.gl_acc_name }}</option>
                  </optgroup>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.product-informations
            >
              Product Informations
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="product-informations" visible>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group
                class="mb-3"
                v-if="pdt_sku"
                label="SKU"
                :label-class="allow_duplicate_pdt ? 'required' : ''"
                label-for="basic"
              >
                <input
                  v-model.trim="field.pdt_sku"
                  name="pdt_sku"
                  :class="{ 'form-control': true }"
                  type="text"
                  data-vv-name="SKU"
                  id="pdt_sku"
                  v-validate="
                  allow_duplicate_pdt ? 'required|max:200' : 'max:200'
                "
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="5" md="6" sm="8">
              <!--HSN code of the product create fields  -->
              <b-form-group v-if="pdt_hsn" label="HSN/SAC " label-for="basic" class="mb-3">
                <input
                  name="pdt_hsn"
                  v-model.trim="field.pdt_hsn"
                  :class="{ 'form-control': true }"
                  type="text"
                  data-vv-name="HSN"
                  id="pdt_hsn"
                  v-validate="'max:8|numeric'"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" lg="5" md="6" sm="8">
              <!--Name of the legacy id  -->
              <b-form-group label="Legacy Id" label-for="basic" class="mb-3">
                <input
                  v-model.trim="field.pdt_legacy_id"
                  name="pdt_legacy_id"
                  :class="{ 'form-control': true }"
                  type="text"
                  id="pdt_legacy_id"
                  data-vv-name="legacy id"
                  v-validate="'max:15'"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group label="Product Tags" label-for="product-tag-select" class="mb-3">
                <b-input-group class="vselect-custom-add">
                  <template slot="append">
                    <b-input-group-text
                      class="vselect-custom-add-icon"
                      v-on:click="
                      (producttagmodal = true),
                        (updatetag = false),
                        calltagmodal({ tag_id: '', tag_name: '' })
                    "
                    >&#43;</b-input-group-text>
                  </template>
                  <template slot="prepend">
                    <v-select
                      :clearable="false"
                      multiple
                      size="sm"
                      :options="producttaglist"
                      label="label"
                      index="value"
                      id="tags-select"
                      v-model.trim="field.pdt_tags"
                    >
                      <template slot="option" slot-scope="option">
                        <div class="d-flex w-100 v-select-option" :title="option.label">
                          <div class="text-truncate" style="width: 292px">{{ option.label }}</div>
                          <span class="select-hover-block">
                            <span
                              class="la la-edit la-lg float-right mr-2"
                              v-on:click.stop="
                              (producttagmodal = true),
                                (updatetag = true),
                                calltagmodal({
                                  tag_id: option.value,
                                  tag_name: option.label,
                                })
                            "
                            ></span>
                            <span
                              class="fa fa-trash-o fa-lg float-right mt-2p"
                              v-on:click.stop="
                              (producttagsdelete = true),
                                (types = 'pdtdelete'),
                                (method = 'producttagdelete'),
                                calldeletemodal(option.value)
                            "
                            ></span>
                          </span>
                        </div>
                      </template>
                    </v-select>
                    <input type="hidden" v-model.trim="field.pdt_tags" name="pdt_tags" />
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px" class="mt-2">
            <b-col cols="12" lg="10">
              <b-form-group label="Product Description" label-for="default-textarea" class="mb-3">
                <b-form-textarea
                  :rows="4"
                  data-vv-name="description"
                  v-model="field.sales_desc"
                  v-validate="'max:250'"
                  name="prd_description"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
        <b-row
          style="max-width: 1000px"
          class="mt-4 mb-2 pt-2"
          v-if="pdt_settings_details.custom_field.length > 0"
        >
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.collapse-1
            >
              Custom Fields
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="collapse-1" visible>
          <b-row style="max-width: 1000px">
            <b-col
              cols="6"
              lg="5"
              md="6"
              sm="8"
              :key="index"
              v-for="(custom_field, index) in pdt_settings_details.custom_field"
              v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
            >
              <CustomPreview
                v-on:assigncustomvalue="assigncustomvalue($event)"
                :custom="custom_field"
                :disabled="false"
                :modelname="field[custom_field.field_name]"
              />
              <input
                type="hidden"
                :name="custom_field.label_name"
                :data-vv-name="custom_field.label_name"
                v-validate="custom_field.validation"
                v-model="field[custom_field.field_name]"
              />
            </b-col>
          </b-row>
        </b-collapse>
        <!-- Reporting tag fields -->
        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.reportingtag
            >
              Reporting Tags
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="reportingtag" visible>
          <b-row style="max-width: 1000px">
            <!-- Billing Address details tab -->
            <b-col v-if="reporting_tags.length == 0">
              <p class="text-muted">You've not created any Reporting Tags.</p>
            </b-col>
            <b-col
              v-else-if="
              reporting_tags.filter(
                (tag) =>
                  (tag.status === '0' && field[tag.tag_column_name] != '') ||
                  tag.status === '1'
              ).length == 0
            "
            >
              <p class="text-muted">
                There are no active reporting tags or you've not created a
                reporting tag yet.You can create/edit reporting tags under
                settings
              </p>
            </b-col>
            <template v-else>
              <b-col
                cols="12"
                lg="5"
                md="6"
                sm="8"
                v-for="(tag, index) in reporting_tags"
                :key="index"
                v-if="tag.status === '1' || show_reporting_tag[index].used"
              >
                <b-form-group
                  :label-for="'tag field' + index"
                  :label="tag.tag_name"
                  label-class="text-truncate"
                  v-if="
                  tag.tag_options.filter(
                    (x) =>
                      (x.is_active == false &&
                        show_reporting_tag[index][tag.tag_column_name] ==
                          x.value) ||
                      x.is_active
                  ).length > 0
                "
                >
                  <v-select
                    :clearable="
                    field[tag.tag_column_name] != '' &&
                    field[tag.tag_column_name] != null
                  "
                    @input="
                    $event == null ? (field[tag.tag_column_name] = '') : ''
                  "
                    v-model="field[tag.tag_column_name]"
                    index="value"
                    label="label"
                    :options="
                    tag.tag_options.filter(
                      (x) =>
                        (x.is_active == false &&
                          show_reporting_tag[index][tag.tag_column_name] ==
                            x.value) ||
                        x.is_active
                    )
                  "
                    class="form-vselect"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-flex w-100 v-select-option" :title="option.label">
                        <div class="text-truncate" style="width: 100%">{{ option.label }}</div>
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
        </b-collapse>

        <!-- Footer field -->
        <div class="footer" style="box-shadow: 0 -4px 5px -3px #ccc">
          <div class="form-action" style="background: none !important; margin: 0px">
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
            </b-button>
          </div>
        </div>
        <!--End Footer field -->
      </b-form>
      <TagModal
        v-if="producttagmodal"
        :tag_id="modal_tag_id"
        module="products"
        v-on:setMultipleAddedRef="getProductMultipleAddedRef"
      ></TagModal>

      <ExemptReason
        v-if="excemptmodal"
        :exempt_reason="modal_exempt_reason"
        module="products"
        v-on:setMultipleAddedRefExempt="getMultipleAddedRefExempt"
      ></ExemptReason>
      <DeleteDropdown
        v-if="producttagsdelete || excemptdelete"
        id="product-dropdown-delete"
        content="Are you sure to delete selected detail?"
        module="general"
        :types="types"
        :method="method"
        v-on:setDropdownDelete="getDropdownDelete"
        :value="deletedropdownid"
      ></DeleteDropdown>
      <CustomUnit :customizedUnit="customizedUnit()"></CustomUnit>
    </div>
  </div>
</template>
<!--script for product create pages -->
<script>
import Vue from "vue";
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import CustomUnit from "@/components/Modal/Product/CustomUnit";
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import vSelect from "vue-select";
import TagModal from "@/components/Modal/TagModal";
import DeleteDropdown from "@/components/Modal/DeleteDropdown";
import ExemptReason from "@/components/Modal/ExemptReason";
import $ from "jquery"; // for using jquery function
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  mixins: [notificationMixin],
  name: "ProductCreate",
  components: {
    vSelect,
    TagModal,
    DeleteDropdown,
    ExemptReason,
    CustomPreview,
    CustomUnit,
    RecordNotFound
  },
  data() {
    return {
      show_reporting_tag: [],
      reportTagCollapse: "",
      duplicatecode: false,
      updatetag: false,
      modal_exempt_reason: "",
      producttagsdelete: false,
      excemptmodal: false,
      excemptdelete: false,
      producttagmodal: false,
      customCollapse: "",
      intra_sales_tax_percent: "",
      types: "",
      method: "",
      inter_sales_tax_percent: "",
      FormUpdate: 0,
      pdt_hsn: "",
      pdt_img: "",
      is_digital_service: "",
      pdt_sku: "",
      error_show: false,
      modal_tag_id: {},
      taxable_preference: [
        {
          text: "Taxable",
          value: "1"
        },
        {
          text: "Tax Exempt",
          value: "0"
        }
      ],
      type: [
        {
          text: "Goods",
          value: "1"
        },
        {
          text: "Service",
          value: "2"
        }
      ],

      submitted: false,
      imageSrc: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: this.createFreshEventObject(),
      imageFiles: [],
      deletedropdownid: "",
      color: {
        hex: "#cccccc"
      }
    };
  },
  methods: {
    redirectPage() {
      if (this.$route.query.clone_id||this.$route.query.old_id) {
        this.$router.push({
          name: "ProductView",
          params: { id: this.$route.query.clone_id||this.$route.query.old_id }
        });
      } else {
        if (this.$store.state.products.pdt_index_history) {
          this.$router.push(this.$store.state.products.pdt_index_history);
        }
        else {
        this.$router.push({ name: "Product" });
      }
      }
    },
    customizedUnit() {
      if (this.field.pdt_unit != "") {
        if (
          this.unit_list.findIndex(x => x.value == this.field.pdt_unit) == -1
        ) {
          this.field.pdt_unit = "";
        }
      }
    },
    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    getMultipleAddedRefExempt(ev) {
      if (ev.close) {
        this.excemptmodal = false;
        return;
      }
      this.field.exempt_reason = "";
      this.field.exempt_reason = this.updatedtag_id;
    },
    callexemptmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addexempt");
        this.modal_exempt_reason = val;
      });
    },
    updateFields() {
      this.field.pdt_name = this.list.pdt_name;
      // for (var i = 0; i < 3; i++) {
      //   this.field[
      //     this.pdt_settings_details.custom_field[i].field_name
      //   ] = this.list[this.pdt_settings_details.custom_field[i].field_name];
      // }

      this.field.sales_desc = this.list.sales_desc;
      for (var i = 0; i < this.pdt_settings_details.custom_field.length; i++) {
        this.field[
          this.pdt_settings_details.custom_field[i].field_name
        ] = this.list[this.pdt_settings_details.custom_field[i].field_name];
      }
      this.field.pdt_sal_price = parseFloat(this.list.pdt_sal_price);
      this.field.pdt_sku = this.pdt_sku ? this.list.pdt_sku : "";
      this.field.is_digital_service = this.list.is_digital_service;
      this.field.pdt_unit = this.list.pdt_unit;
      this.field.pdt_hsn = this.list.pdt_hsn;
      this.field.pdt_state = this.list.pdt_state;
      this.field.pdt_legacy_id = this.list.pdt_legacy_id;
      this.field.pdt_tax_type = this.list.pdt_tax_type;
      this.field.tax_preference = this.list.tax_preference;
      this.field.pdt_id = "";
      if (this.list.exempt_reason == "" || this.list.exempt_reason == null) {
        this.field.exempt_reason = "";
      } else {
        this.field.exempt_reason = this.list.exempt_reason;
      }
      var inter_Tax_id = this.list.pdt_inter_tax_id;
      var pdt_Tax_id = this.list.pdt_tax_id;
      $.each(this.igst_tax, (key, value) => {
        if (value["tax_id"] == inter_Tax_id) {
          this.inter_sales_tax_percent = value["sales_tax_percent"];
          this.field.pdt_inter_tax_id = {
            label: value["tax_name"],
            value: value["tax_id"]
          };
        }
      });
      $.each(this.local_tax, (key, value) => {
        if (value["tax_id"] == pdt_Tax_id) {
          this.intra_sales_tax_percent = value["sales_tax_percent"];
          this.field.pdt_tax_id = {
            label: value["tax_name"],
            value: value["tax_id"]
          };
        }
      });

      //update to fields for reporting tag field values
      //update to fields for reporting tag field values
      for (var i = 0; i < this.reporting_tags.length; i++) {
        this.show_reporting_tag.push({
          used:
            this.list[this.reporting_tags[i].tag_column_name] != "" &&
            this.list[this.reporting_tags[i].tag_column_name] != null
              ? true
              : false,
          [this.reporting_tags[i].tag_column_name]: this.list[
            this.reporting_tags[i].tag_column_name
          ]
        });
        this.field[this.reporting_tags[i].tag_column_name] = this.list[
          this.reporting_tags[i].tag_column_name
        ]
          ? parseInt(this.list[this.reporting_tags[i].tag_column_name])
          : "";
      }
      this.field.pdt_sales_account = this.list.sales_account;

      this.field.pdt_tags = this.list.pdt_tags;
      if (this.image != "") {
        this.imageSrc = `data:image/jpeg;base64,` + this.image;
      }
    },
    //  add the newly added fields
    getProductMultipleAddedRef(ev) {
      if (ev.close) {
        this.producttagmodal = false;
        return;
      }
      var value = this.updatedtag_id;
      if (this.updatetag != true) {
        this.field.pdt_tags.push(value);
      }
    },
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];
          // alert(hasMatch);
          break;
        }
      }
      return hasMatch;
    },

    intra_tax_id(ev) {
      this.intra_sales_tax_percent = ev.sales_tax_percent;
    },
    inter_tax_id(ev) {
      this.inter_sales_tax_percent = ev.sales_tax_percent;
    },
    //  call delete dropdown modal
    calldeletemodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "product-dropdown-delete");
        this.deletedropdownid = val;
      });
    },

    getDropdownDelete(ev) {
      if (ev.close) {
        this.producttagsdelete = false;
        this.excemptdelete = false;
        return;
      }
      if (ev == 200) {
        if (this.method == "producttagdelete") {
          if (this.field.pdt_tags != []) {
            var index = this.field.pdt_tags.indexOf(this.deletedropdownid);
            if (index != -1) {
              this.field.pdt_tags.splice(index, 1);
              this.deletedropdownid = "";
            }
          }
        } else if (this.method == "exemptdelete") {
          var id = this.getPresentValue(
            this.exempt_reason_list,
            "label",
            ev.label,
            "value"
          );

          this.field.exempt_reason = id;
        }
      }
    },
    //  for rounding off total maount modal
    roundOffItem(field, digits) {
      var digit = parseInt(digits);
      this.field[field] =
        typeof this.field[field] != undefined &&
        !isNaN(this.field[field]) &&
        this.field[field] != ""
          ? parseFloat(parseFloat(this.field[field]).toFixed(digit))
          : parseFloat(parseFloat(0).toFixed(digit));
    },
    roundOff() {
      this.field.pdt_tax_type =
        this.field.tax_preference == "0" ? "0" : this.field.pdt_tax_type;
      this.field.is_inventory =
        this.field.pdt_state == "2" ? "0" : this.field.is_inventory;
      this.field.pdt_pur_price =
        typeof this.field.pdt_pur_price != undefined &&
        !isNaN(this.field.pdt_pur_price) &&
        this.field.pdt_pur_price != ""
          ? parseFloat(this.field.pdt_pur_price).toFixed(2)
          : parseFloat(0).toFixed(2);
      this.field.opening_stock =
        typeof this.field.opening_stock != undefined &&
        !isNaN(this.field.opening_stock) &&
        this.field.opening_stock != ""
          ? parseFloat(this.field.opening_stock).toFixed(2)
          : parseFloat(0).toFixed(2);

      this.field.opening_stock_value =
        typeof this.field.opening_stock_value != undefined &&
        !isNaN(this.field.opening_stock_value) &&
        this.field.opening_stock_value != ""
          ? parseFloat(this.field.opening_stock_value).toFixed(2)
          : parseFloat(0).toFixed(2);

      this.field.reorder_level =
        typeof this.field.reorder_level != undefined &&
        !isNaN(this.field.reorder_level) &&
        this.field.reorder_level != ""
          ? parseFloat(this.field.reorder_level).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    calltagmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addTag");
        this.modal_tag_id = val;
      });
    },

    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.submitted = true;
          this.duplicatecode = false;
          var form_data = new FormData();

          form_data.append("pdt_image", this.imageFiles[0]);
          form_data.append(
            "field",
            JSON.stringify({
              field: this.field
            })
          );
          this.$store
            .dispatch("products/createList", form_data)
            .then(() => {
              this.FormUpdate = 0; // to hide before route leave confirmation message
             
              if (this.status_code == 200) {
                this.$router.push({
                  name: "ProductView",
                  params: { id: this.updated_id }
                });
                this.event = this.createFreshEventObject();
               
              } else {
                this.submitted = false;
                this.duplicatecode = true;
              }
               window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: this.status_type,
                showCloseButton: true
              });
            })
            .catch(() => {});
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true;
          //   Messenger().post({
          //     extraClasses: this.locationClasses,
          //     message: "Please fill all the required fields",
          //     type: "danger",
          //     showCloseButton: true
          //   });
        }
      });
      return false;
    },

    createFreshEventObject() {
      return {
        pdt_tags: [],
        pdt_name: "",
        is_selling_price: 1,
        pdt_inter_tax_id: "",
        is_digital_service: 0,
        pdt_tax_id: "",
        pdt_sal_price: "",
        pdt_sku: "",
        pdt_unit: "",
        pdt_cat: 1,
        pdt_hsn: "",
        pdt_image: "",
        sales_desc: "",
        pdt_sales_account: "",
        pdt_state: "2",
        pdt_legacy_id: "",
        pdt_tax_type: "",
        pdt_incl_intra_price: "0.00",
        pdt_incl_inter_price: "0.00",
        pdt_pur_incl_intra_price: "0.00",
        pdt_pur_incl_inter_price: "0.00",
        is_inventory: "",
        reorder_level: "",
        opening_stock_value: "",
        opening_stock: "",
        inventory_accounts: "",
        tax_preference: "1",
        exempt_reason: "",
        purchase_desc: "",
        warehouse_id: ""
      };
    },
    onChangeInputImage(e) {
      const files = [];
      const reader = new FileReader();
      files.push(e.target.files[0]);
      reader.onloadend = () => {
        files[0].preview = reader.result;
        files[0].toUpload = true;
        Vue.set(this, "imageFiles", files);
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    deleteimage() {
      Vue.set(this, "imageFiles", []);
    },

    changeColor(e) {
      Vue.set(this, "color", {
        hex: e.value
      });
    },
    inclusiveAmount() {
      var pdt_pur_incl_inter_price = 0;
      var pdt_pur_incl_intra_price = 0;
      var pdt_incl_intra_price = 0;
      var pdt_incl_inter_price = 0;
      if (this.field.pdt_tax_type == 1 && this.field.pdt_sal_price > 0) {
        if (this.intra_sales_tax_percent) {
          pdt_incl_intra_price = this.pdt_incl_inter_price = parseFloat(
            parseFloat(this.field.pdt_sal_price) /
              (1 + parseFloat(this.intra_sales_tax_percent) / 100)
          ).toFixed(2);
        }
        if (this.inter_sales_tax_percent) {
          pdt_incl_inter_price = this.pdt_incl_inter_price = parseFloat(
            parseFloat(this.field.pdt_sal_price) /
              (1 + parseFloat(this.inter_sales_tax_percent) / 100)
          ).toFixed(2);
        }
      }
      if (this.field.pdt_tax_type == 1 && this.field.pdt_pur_price > 0) {
        if (this.intra_sales_tax_percent) {
          pdt_pur_incl_intra_price = this.pdt_pur_incl_inter_price = parseFloat(
            parseFloat(this.field.pdt_pur_price) /
              (1 + parseFloat(this.intra_sales_tax_percent) / 100)
          ).toFixed(2);
        }
        if (this.inter_sales_tax_percent) {
          pdt_pur_incl_inter_price = this.pdt_pur_incl_inter_price = parseFloat(
            parseFloat(this.field.pdt_pur_price) /
              (1 + parseFloat(this.inter_sales_tax_percent) / 100)
          ).toFixed(2);
        }
      }
      this.field.pdt_incl_intra_price =
        isNaN(pdt_incl_intra_price) ||
        pdt_incl_intra_price == "" ||
        pdt_incl_intra_price == null ||
        typeof pdt_incl_intra_price == "undefined"
          ? 0
          : parseFloat(pdt_incl_intra_price);
      this.field.pdt_incl_inter_price =
        isNaN(pdt_incl_inter_price) ||
        pdt_incl_inter_price == "" ||
        pdt_incl_inter_price == null ||
        typeof pdt_incl_inter_price == "undefined"
          ? 0
          : parseFloat(pdt_incl_inter_price);
      this.field.pdt_pur_incl_intra_price =
        isNaN(pdt_pur_incl_intra_price) ||
        pdt_pur_incl_intra_price == "" ||
        pdt_pur_incl_intra_price == null ||
        typeof pdt_pur_incl_intra_price == "undefined"
          ? 0
          : parseFloat(pdt_pur_incl_intra_price);
      this.field.pdt_pur_incl_inter_price =
        isNaN(pdt_pur_incl_inter_price) ||
        pdt_pur_incl_inter_price == "" ||
        pdt_pur_incl_inter_price == null ||
        typeof pdt_pur_incl_inter_price == "undefined"
          ? 0
          : parseFloat(pdt_pur_incl_inter_price);
      return {
        pdt_incl_intra_price: pdt_incl_intra_price,
        pdt_incl_inter_price: pdt_incl_inter_price,
        pdt_pur_incl_inter_price: pdt_pur_incl_inter_price,
        pdt_pur_incl_intra_price: pdt_pur_incl_intra_price
      };
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("products/fetchProductDetails").then(() => {
      store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Product",
        stg_name: "pdt_settings_details"
      });
      next();
    });
  },
  async created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    this.pdt_hsn = this.pdt_settings_details.pdt_hsn_sac;
    this.allow_duplicate_pdt = this.pdt_settings_details.allow_duplicate_pdt;
    this.pdt_sku = this.pdt_settings_details.pdt_sku;
    this.pdt_img = this.pdt_settings_details.pdt_img;
    this.is_digital_service = this.pdt_settings_details.is_digital_service;
    //update to fields for reporting tag field values
    for (var i = 0; i < this.reporting_tags.length; i++) {
      this.show_reporting_tag.push({
        used: "",
        [this.reporting_tags[i].tag_column_name]: ""
      });
      this.$set(this.field, this.reporting_tags[i].tag_column_name, "");
    }
    for (var i = 0; i < this.pdt_settings_details.custom_field.length; i++) {
      if (
        this.pdt_settings_details.custom_field[i].status == 1 &&
        this.pdt_settings_details.custom_field[i].permissions == "write"
      ) {
        this.$set(
          this.field,
          this.pdt_settings_details.custom_field[i].field_name,
          this.pdt_settings_details.custom_field[i].default_value
        );
      }
    }
    if (this.$route.query.clone_id) {
      await this.updateFields();
    }
    //  to watch any updates in details data
    this.$watch(
      "field",
      function() {
        this.FormUpdate = 1;
      },
      {
        deep: true
      }
    );
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  computed: {
    ...mapState({
      status_code: state => state.products.status_code,
      status_message: state => state.products.status_message,
      status_type: state => state.products.status_type,
      igst_tax: state => state.products.igst_tax,
      local_tax: state => state.products.local_tax,
      sales_account: state => state.products.sales_account,
      inventory_accounts: state => state.products.inventory_accounts,
      producttaglist: state => state.products.producttaglist,
      code: state => state.products.code,
      message: state => state.products.message,
      updated_id: state => state.products.updated_id,
      unit_list: state => state.products.unit_list,
      acc_types: state => state.products.acc_types,
      exempt_reason_list: state => state.products.exempt_reason_list,
      purchase_account: state => state.products.purchase_account,
      updatedtag_id: state => state.products.updatedtag_id,
      list: state => state.products.list
    }),
    ...mapGetters([
      "org_details",
      "orgCurrency",
      "pdt_settings_details",
      "reporting_tags"
    ])
  }
};
</script>
<!--script for product create pages -->
<!--style for product create pages -->
<style src="./Products.scss" lang="scss" />
